import React, { useState, useEffect, FC } from 'react'
import { Table, Select } from 'antd'
import { YhBox } from '@/components/YhBox'
import { RouterParamType } from '@/model/navModel'
import { useInquiryContrastModel } from './inquiryContrastModel'
import { ColumnsType } from 'antd/lib/table'
import { IInquiryGoods, IInquiryGoodsForContrast } from '../../inquiryTypes'
import YhTootip from '@/components/YhTootip'
import YhDebounceSelect from '@/components/YhDounceSelect'
import useGlobalModel from '@/model/globalModel'
import { ISelectOption } from '@/components/YhFormBox/Types'
export const Mavb: FC<RouterParamType> = ({ id, mode }) => {
    const {
        mavbList,
        setMavbList,
        mavbChoosedSupplierCode,
        setMavbChoosedSupplierCode,
        mavbChoosedInquiryId,
        setMavbChoosedInquiryId,
        getInquiryList,
        getGoodsList,
        changeMavbList,
        changeViceInquiryList,
    } = useInquiryContrastModel()
    const { fetchSupplierList } = useGlobalModel()

    const [inquiryCodeOptions, setInquiryCodeOptions] = useState<ISelectOption[]>([])
    const [defaultSupplierName, setDefaultSupplierName] = useState<string | undefined>(undefined)

    useEffect(() => {
        setMavbChoosedInquiryId(undefined)
        setMavbList([])
        setInquiryCodeOptions([])
        mavbChoosedSupplierCode && inquiryList(mavbChoosedSupplierCode)
    }, [mavbChoosedSupplierCode])

    //切换询价单，获取商品列表
    useEffect(() => {
        if (mavbChoosedInquiryId) {
            getGoodsList(mavbChoosedInquiryId).then((res) => {
                if (res) {
                    const { sumInquiryDetailsList } = res
                    changeMavbList(sumInquiryDetailsList || [])
                }
            })
        }
    }, [mavbChoosedInquiryId])

    const inquiryList = (mavbChoosedSupplierCode: string) => {
        getInquiryList(mavbChoosedSupplierCode).then((res) => {
            if (res) {
                const { records } = res
                if (records && records.length > 0) {
                    setInquiryCodeOptions(records.map((i) => ({ value: i.id, label: i.inquiryCode })))
                }
            }
        })
    }

    //初始化进入页面由id
    useEffect(() => {
        if (id) {
            getGoodsList(id).then((res) => {
                if (res) {
                    const { sumInquiryDetailsList, supplierName, supplierCode, inquiryCode } = res
                    setDefaultSupplierName(supplierName)
                    setMavbChoosedInquiryId(id)
                    setMavbChoosedSupplierCode(supplierCode)
                    inquiryList(supplierCode)
                    changeMavbList(sumInquiryDetailsList || [])
                    changeViceInquiryList('main','inquiryCode',inquiryCode)
                    changeViceInquiryList('main', 'supplierCode',supplierCode)
                    changeViceInquiryList('main', 'supplierName',supplierName)
                }
            })
        }
    }, [id])

    const columns: ColumnsType<IInquiryGoodsForContrast> = [
        {
            title: '序号',
            width: 40,
            align: 'left',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '商品名称',
            width: 200,
            align: 'left',
            dataIndex: 'materialName',
            render: (text: string) => <YhTootip style={{ width: '100%' }} text={text} />,
        },

        {
            title: '商品编号',
            width: 180,
            align: 'left',
            dataIndex: 'materialCode',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '品牌',
            width: 100,
            align: 'left',
            dataIndex: 'brandName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单位',
            width: 100,
            align: 'left',
            dataIndex: 'unitName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '单价',
            width: 100,
            align: 'left',
            fixed: 'right',
            dataIndex: 'price',
            render: (text: string) => <YhTootip text={text} />,
        },
       
    ]

    return (
        <div style={{ margin: '10px', width: 'calc((100vw - 285px) / 3)' }}>
            <YhBox>
                <div style={{ display: 'flex', padding: '0 10px 10px 10px' }}>
                    <YhDebounceSelect
                        style={{ flex: 1, marginRight: '10px' }}
                        showSearch
                        className="border-r-16"
                        placeholder="供应商"
                        fetchOptions={fetchSupplierList}
                        onChange={(v,o) => {
                            changeViceInquiryList('main','supplierCode',v)
                            changeViceInquiryList('main','supplierName',(o as {label: string}).label)
                            setMavbChoosedSupplierCode(v as string)
                        }}
                        value={mavbChoosedSupplierCode}
                        defaultQuery={defaultSupplierName}
                    />
                    <Select
                        style={{ flex: 1 }}
                        showSearch
                        className="border-r-16"
                        placeholder="询价单号"
                        options={inquiryCodeOptions}
                        value={mavbChoosedInquiryId}
                        onChange={(v,o) => {
                            changeViceInquiryList('main','inquiryCode',(o as {label: string}).label)
                            setMavbChoosedInquiryId(v as string)
                        }}
                    />
                </div>
                <Table
                    style={{ width: 'calc((100vw - 285px) / 3)', minHeight:"680px" }}
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={mavbList}
                    pagination={false}
                    scroll={{ x: 'max-content' , y: '640px'}}
                    locale={{
                        emptyText: (
                            <div style={{ minHeight: '600px', textAlign: 'center', lineHeight: '600px' }}>
                                暂无数据
                            </div>
                        ),
                    }}
                />
            </YhBox>
        </div>
    )
}
